document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('.js-link-collection-carousel');
    window.link_collection_carousels = {};

    carousels.forEach(function (splideElement) {
        var carouselCardSettings = {
            type: 'slide',
            arrows: true,
            perPage: 4,
            perMove: 1,
            pagination: false,
            gap: 'clamp(0.5rem, 1vw, 0.75rem)',
            arrowPath: ' ',
            mediaQuery: 'min',
            breakpoints: {
                0: {
                    perPage: 1,
                },
                757: {
                    perPage: 2,
                },
                1163: {
                    perPage: 3,
                },
                1350: {
                    destroy: true,
                },
            },
            i18n: {
                prev: splideElement.getAttribute('data-label-prev'),
                next: splideElement.getAttribute('data-label-next'),
                first: splideElement.getAttribute('data-label-first'),
                last: splideElement.getAttribute('data-label-last'),
                slideX: splideElement.getAttribute('data-label-slideX'),
                pageX: splideElement.getAttribute('data-label-pageX'),
                carousel: splideElement.getAttribute('data-label-carousel'),
                select: splideElement.getAttribute('data-label-select'),
                slide: splideElement.getAttribute('data-label-slide'),
                slideLabel: '%s / %s',
            },
        };

        var splide = new Splide(splideElement, carouselCardSettings);

        // Store a reference to the Splide object in the Splide element
        window.link_collection_carousels[
            splideElement.getAttribute('data-carousel-id')
        ] = splide;

        // Update live region on slide change
        updateSlideScreenReaderText(splide, splideElement);

        splide.mount();
    });
});
